<template>
  <Card class="page-patientConfig">
    <div style="display: flex; margin-bottom: 15px">
      <div style="flex: 1; display: flex">
        <!-- <el-input
          v-model="keywords"
          style="max-width: 350px"
          placeholder="请输入名称"
        />
        <el-button
          type="primary"
          round
          style="margin-left: 30px"
          @click="queryModuleList"
          >搜索</el-button
        >-->
      </div>
      <el-button type="primary" round style="margin-left: 230px" @click="addModule">新增模块</el-button>
    </div>
    <configTable
      :dataSource="dataSource"
      :columns="columns"
      :businessColumns="businessColumns"
      :childColumns="childColumns"
      :loading="loading"
    />
    <div style="margin-top: 16px; text-align: right">
      <Page
        :transfer="true"
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
    <Modal v-model="moduleModal" width="550">
      <div slot="header" style="text-align: center">
        <span>{{ curModule.id ? "修改模块" : "新增模块" }}</span>
      </div>
      <Form
        ref="module"
        :model="curModule"
        :label-width="120"
        :rules="moduleRule"
        label-position="right"
        style="margin-left: -40px;margin-right: 40px"
      >
        <FormItem label="模块名称" prop="name">
          <Input v-model.trim="curModule.name" :maxlength="30" placeholder="请填写模块名称"></Input>
        </FormItem>
        <FormItem label="模块别名" prop="alias">
          <Input v-model.trim="curModule.alias" :maxlength="30" placeholder="请填写模块别名"></Input>
        </FormItem>
        <FormItem label="模块路由" prop="route">
          <Input v-model.trim="curModule.route" :maxlength="30" placeholder="请填写模块路由"></Input>
        </FormItem>
        <FormItem label="模块类型" required prop="type">
          <Select v-model="curModule.type" :disabled="!!(curModule.id || curModule.pid)">
            <Option value="目录" key="目录">目录</Option>
            <Option value="业务" key="业务">业务</Option>
          </Select>
        </FormItem>
        <FormItem label="排序" prop="sort">
          <InputNumber
            v-model.trim="curModule.sort"
            :min="-999"
            :max="999"
            :activeChange="false"
            style="width: 100%"
            type="number"
            placeholder="请填写摘要排序"
          ></InputNumber>
        </FormItem>
        <FormItem required label="状态" prop="show">
          <Select v-model="curModule.show">
            <Option :value="1" :key="1">展示</Option>
            <Option :value="0" :key="0">不展示</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelModule">取消</el-button>
        <el-button type="primary" round :loading="moduleModalLoading" @click="saveModule">保存</el-button>
      </div>
    </Modal>
    <Modal v-model="businessModal" width="550">
      <div slot="header" style="text-align: center">
        <span>{{ curBusiness.id ? "修改业务" : "新增业务" }}</span>
      </div>
      <Form
        ref="bus"
        :model="curBusiness"
        :label-width="150"
        :rules="businessRule"
        label-position="right"
        style="margin-left: -40px;margin-right: 40px"
      >
        <FormItem label="业务名称" prop="name">
          <Input v-model.trim="curBusiness.name" placeholder="请填写业务名称"></Input>
        </FormItem>
        <FormItem label="业务编码" prop="code">
          <Input v-model.trim="curBusiness.code" placeholder="请填写业务编码"></Input>
        </FormItem>
        <FormItem label="业务路由" prop="route">
          <Input v-model.trim="curBusiness.route" placeholder="请填写业务路由"></Input>
        </FormItem>
        <FormItem label="业务绑定表单" prop="bind_name">
          <Input v-model.trim="curBusiness.bind_code" placeholder="请填写业务绑定表单" @on-focus="showModal"></Input>
        </FormItem>
        <FormItem label="趋势图表开关" required>
          <Select v-model="curBusiness.show_trend">
            <Option :value="0" :key="0">关</Option>
            <Option :value="1" :key="1">开</Option>
          </Select>
        </FormItem>
        <FormItem v-if="curBusiness.show_trend == 1" required label="趋势类型">
          <Select v-model="curBusiness.trend_type" clearable>
            <Option :value="0" :key="0">分值</Option>
            <Option :value="1" :key="1">答案</Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="curBusiness.bind_code && curBusiness.show_trend == 1 && curBusiness.trend_type == 1 && question.length"
          required
          label="趋势编码"
        >
          <Select v-model="curBusiness.trend_code">
            <Option
              v-for="it in question"
              :value="it.value.id"
              :key="it.value.id"
            >{{ questionType(it.value) }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelBusiness">取消</el-button>
        <el-button type="primary" round :loading="businessModalLoading" @click="saveBusiness">保存</el-button>
      </div>
    </Modal>
    <questionModal :isModal="isModal" @save="saveModal" @cancel="cancelModal"></questionModal>
  </Card>
</template>
<script>
import configTable from './configTable.vue'
import caringItemTable from '../../../components/caring-item-table'
import questionModal from '../../common/questionModal.vue'
import {
  getModuleListApi,
  editModuleApi,
  editBusinessApi,
  deleteModuleApi,
  deleteBusinessApi,
} from '../../../api/config'
export default {
  components: {
    questionModal,
    configTable,
  },
  props: {
    configType: {
      type: String | Number,
      default: '',
    },
  },
  data() {
    return {
      columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return params.row.type === '目录'
              ? h(caringItemTable, {
                  props: {
                    dataSource: params.row.child_modules,
                    columns: this.childColumns,
                  },
                })
              : h(caringItemTable, {
                  props: {
                    dataSource: params.row.businesses,
                    columns: this.businessColumns,
                  },
                })
          },
        },
        {
          title: '模块名称',
          align: 'center',
          key: 'name',
        },
        {
          title: '模块别名',
          align: 'center',
          key: 'alias',
        },
        {
          title: '模块类型',
          align: 'center',
          key: 'type',
        },
        {
          title: '模块路由',
          align: 'center',
          key: 'route',
        },
        {
          title: '排序',
          align: 'center',
          key: 'sort',
        },
        {
          title: '创建时间',
          align: 'center',
          key: 'create_time',
          width: 120,
        },
        {
          title: '状态',
          align: 'center',
          key: 'show',
          render: (h, props) => {
            return h('div', props.row.show == 1 ? '展示' : '不展示')
          },
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          prop: 'action',
          width: 220,
          slot: 'action',
          render: (h, props) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: {
                    type: 'text',
                  },
                  style: {
                    marginRight: '10px',
                  },
                  on: {
                    click: () => {
                      this.editModule(props.row)
                    },
                  },
                },
                '修改'
              ),
              h('el-popconfirm', {
                props: {
                  title: '确定删除这一模块吗？',
                  placement: 'top',
                },
                scopedSlots: {
                  reference: () => {
                    return h(
                      'el-button',
                      {
                        props: {
                          type: 'text',
                        },
                        class: 'error',
                      },
                      '删除'
                    )
                  },
                },
                on: {
                  confirm: () => {
                    this.deleteModule(props.row)
                  },
                },
              }),
              props.row.type === '目录'
                ? h(
                    'el-button',
                    {
                      props: {
                        type: 'text',
                      },
                      style: {
                        marginLeft: '10px',
                      },
                      on: {
                        click: () => {
                          this.addBusModule(props.row)
                        },
                      },
                    },
                    '新增'
                  )
                : props.row.businesses.length < 1
                ? h(
                    'el-button',
                    {
                      props: {
                        type: 'text',
                      },
                      style: {
                        marginLeft: '10px',
                      },
                      on: {
                        click: () => {
                          this.addBusiness(props.row)
                        },
                      },
                    },
                    '新增'
                  )
                : h('div', ''),
            ])
          },
        },
      ],
      childColumns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return h(caringItemTable, {
              props: {
                dataSource: params.row.businesses,
                columns: this.businessColumns,
              },
            })
          },
        },
        {
          title: '模块名称',
          align: 'center',
          key: 'name',
        },
        {
          title: '模块别名',
          align: 'center',
          key: 'alias',
        },
        {
          title: '模块类型',
          align: 'center',
          key: 'type',
        },
        {
          title: '模块路由',
          align: 'center',
          key: 'route',
        },
        {
          title: '排序',
          align: 'center',
          key: 'sort',
        },
        {
          title: '创建时间',
          key: 'create_time',
          align: 'center',
          width: 120,
        },
        {
          title: '状态',
          align: 'center',
          key: 'show',
          render: (h, props) => {
            return h('div', props.row.show == 1 ? '展示' : '不展示')
          },
        },
        {
          title: '操作',
          align: 'center',
          key: 'action',
          prop: 'action',
          width: 220,
          slot: 'action',
          render: (h, props) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: {
                    type: 'text',
                  },
                  style: {
                    marginRight: '10px',
                  },
                  on: {
                    click: () => {
                      this.editModule(props.row)
                    },
                  },
                },
                '修改'
              ),
              h('el-popconfirm', {
                props: {
                  title: '确定删除这一模块吗？',
                  placement: 'top',
                },
                scopedSlots: {
                  reference: () => {
                    return h(
                      'el-button',
                      {
                        props: {
                          type: 'text',
                        },
                        class: 'error',
                      },
                      '删除'
                    )
                  },
                },
                on: {
                  confirm: () => {
                    this.deleteModule(props.row)
                  },
                },
              }),
              h(
                'el-button',
                {
                  props: {
                    type: 'text',
                  },
                  style: {
                    marginLeft: '10px',
                  },
                  on: {
                    click: () => {
                      this.addBusiness(props.row)
                    },
                  },
                },
                '新增'
              ),
            ])
          },
        },
      ],
      businessColumns: [
        {
          title: '业务名称',
          key: 'name',
          align: 'center',
          prop: 'name',
        },
        {
          title: '业务编码',
          key: 'code',
          align: 'center',
          prop: 'code',
        },
        {
          title: '绑定表单/ID',
          align: 'center',
          key: 'bind_name',
          prop: 'bind_name',
          minWidth: 220,
          render: (h, props) => {
            return h('div', props.row.bind_name + '/' + props.row.bind_code)
          },
        },
        {
          title: '创建时间',
          key: 'create_time',
          prop: 'create_time',
          align: 'center',
          width: 120,
        },
        {
          title: '更新时间',
          key: 'update_time',
          align: 'center',
          prop: 'update_time',
          width: 120,
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          prop: 'action',
          width: 130,
          slot: 'action',
          render: (h, props) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: {
                    type: 'text',
                  },
                  style: {
                    marginRight: '10px',
                  },
                  on: {
                    click: () => {
                      this.editBusiness(props.row)
                    },
                  },
                },
                '修改'
              ),
              h('el-popconfirm', {
                props: {
                  title: '确定删除这项业务吗？',
                  placement: 'top',
                },
                scopedSlots: {
                  reference: () => {
                    return h(
                      'el-button',
                      {
                        props: {
                          type: 'text',
                        },
                        class: 'error',
                      },
                      '删除'
                    )
                  },
                },
                on: {
                  confirm: () => {
                    this.deleteBusiness(props.row)
                  },
                },
              }),
            ])
          },
        },
      ],
      keywords: '',
      page: 1,
      size: 10,
      total: 0,
      sizes: [10, 20, 30, 40, 50],
      loading: false,
      dataSource: [],
      moduleModal: false,
      curModule: {
        id: '',
        name: '',
        alias: '',
        type: '',
        route: '',
        sort: 1,
        show: 0,
        disease_id: '',
        disease_name: '',
      },
      moduleModalLoading: false,
      moduleRule: {
        name: [
          {
            required: true,
            message: '请填写模块名称',
            trigger: 'blur',
          },
          { required: true, message: '请填写模块名称', trigger: 'change' },
          // {
          //   pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
          //   message: '请输入由中英文、数字以及下划线组成的模块名称',
          //   trigger: 'blur',
          // },
          // {
          //   pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
          //   message: '请输入由中英文、数字以及下划线组成的模块名称',
          //   trigger: 'change',
          // },
        ],
        alias: [
          {
            required: true,
            message: '请填写模块别名',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请填写模块别名',
            trigger: 'change',
          },
          // {
          //   pattern: /^[a-zA-Z]?\w+$/,
          //   message: '请输入由字母开头,只能包含字母、数字和下划线的模块别名',
          //   trigger: 'blur',
          // },
          // {
          //   pattern: /^[a-zA-Z]?\w+$/,
          //   message: '请输入由字母开头,只能包含字母、数字和下划线的模块别名',
          //   trigger: 'change',
          // },
        ],
        route: [
          {
            required: true,
            message: '请填写模块路由',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请填写模块路由',
            trigger: 'change',
          },
          // {
          //   pattern: /^[a-zA-Z](\w{1})?/,
          //   message: '请输入由字母开头,只能包含字母、数字和下划线的模块路由',
          //   trigger: 'blur',
          // },
          // {
          //   pattern: /^[a-zA-Z](\w{1})?/,
          //   message: '请输入由字母开头,只能包含字母、数字和下划线的模块路由',
          //   trigger: 'change',
          // },
        ],
        sort: [
          {
            type: 'number',
            required: true,
            message: '请填写摘要顺序',
            trigger: 'blur',
          },
        ],
      },
      businessModal: false,
      curBusiness: {
        module_id: '',
        module_name: '',
        name: '',
        code: '',
        route: '',
        bind_name: '',
        bind_code: '',
      },
      businessModalLoading: false,
      businessRule: {
        name: [
          {
            required: true,
            message: '请填写业务名称',
            trigger: 'blur',
          },
          { required: true, message: '请填写业务名称', trigger: 'change' },
          // {
          //   pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
          //   message: '请输入由中英文、数字以及下划线组成的业务名称',
          //   trigger: 'blur',
          // },
          // {
          //   pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
          //   message: '请输入由中英文、数字以及下划线组成的业务名称',
          //   trigger: 'change',
          // },
        ],
        code: [
          {
            required: true,
            message: '请填写业务编码',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请填写业务编码',
            trigger: 'change',
          },
          // {
          //   pattern: /^[a-zA-Z]?\w+$/,
          //   message: '请输入由字母开头,只能包含字母、数字和下划线的业务编码',
          //   trigger: 'blur',
          // },
          // {
          //   pattern: /^[a-zA-Z]?\w+$/,
          //   message: '请输入由字母开头,只能包含字母、数字和下划线的业务编码',
          //   trigger: 'change',
          // },
        ],
        bind_name: [
          {
            required: true,
            message: '请填写业务绑定表单',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请填写业务绑定表单',
            trigger: 'change',
          },
        ],
        route: [
          {
            required: true,
            message: '请填写业务路由',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请填写业务路由',
            trigger: 'change',
          },
          // {
          //   pattern: /^[a-zA-Z]?\w+$/,
          //   message: '请输入由字母开头,只能包含字母、数字和下划线的业务路由',
          //   trigger: 'blur',
          // },
          // {
          //   pattern: /^[a-zA-Z]?\w+$/,
          //   message: '请输入由字母开头,只能包含字母、数字和下划线的业务路由',
          //   trigger: 'change',
          // },
        ],
      },
      isModal: false,
      question: [],
      id: '',
    }
  },
  methods: {
    questionType(type) {
      let res
      if (type.multipleChoiceAttribute) {
        res = type.multipleChoiceAttribute.name
      } else if (type.singleChoiceAttribute) {
        res = type.singleChoiceAttribute.name
      } else if (type.singleLineTextAttribute) {
        res = type.singleLineTextAttribute.name
      } else if (type.fillInBlanksAttribute) {
        res = type.fillInBlanksAttribute.name
      } else if (type.digitalAttribute) {
        res = type.digitalAttribute.name
      } else if (type.scaleAttribute) {
        res = type.scaleAttribute.name
      } else if (type.sliderAttribute) {
        res = type.sliderAttribute.name
      }
      return res
    },
    showModal() {
      this.isModal = true
    },
    saveModal(data) {
      if (data && data.length) {
        this.curBusiness.bind_name = data[0].questionnaire_name
        this.curBusiness.bind_code = data[0].questionnaire_id
        this.isModal = false
        this.curBusiness.trend_code = ''
        this.getInfo(this.curBusiness.bind_code)
      } else {
        this.$Message.warning('请选择相关内容')
      }
    },
    getInfo(id) {
      this.$utils.caringRequest({
        method: 'GET',
        url: this.$utils.getInterface('QUESTIONNAIRE') + '/' + id,
        headers: {
          'content-type': 'application/json',
        },
        surplusHeader: true,
        success: (res) => {
          if (res.code === 0) {
            const arr = []
            res.data.questions.forEach(function (v) {
              if (
                v.type == 'SingleChoiceQuestion' ||
                v.type == 'MultipleChoiceQuestion' ||
                v.type == 'SingleLineTextQuestion' ||
                v.type == 'FillInBlankQuestion' ||
                v.type == 'DigitalQuestion' ||
                v.type == "ScaleQuestion" ||
                v.type == "SliderQuestion"
              ) {
                arr.push(v)
              }
            })
            this.question = arr
          } else {
            this.$Message.error(res.message)
          }
        },
      })
    },
    cancelModal() {
      this.isModal = false
    },
    queryModuleList() {
      this.id = ''
      this.getModuleList()
    },
    onCurrentChange(current) {
      this.page = current
      this.getModuleList()
    },
    onSizeChange(size) {
      this.size = size
      this.getModuleList()
    },
    getModuleList() {
      this.loading = true
      const { keywords, page, size, configType: config_type } = this
      getModuleListApi({ keywords, page, size, config_type }).then((res) => {
        this.loading = false
        if (res.code === 0) {
          this.dataSource = res.data.map((d, di) => {
            if (this.id || this.pid) {
              if (d.id == (this.pid || this.id)) {
                d._expanded = true
              }
            } else if (di === 0) {
              d._expanded = true
            }
            d.businesses = d.businesses || []
            d.child_modules = d.child_modules || []
            d.child_modules.forEach((c) => {
              if (this.id) {
                if (c.id === this.id) {
                  c._expanded = true
                }
              }
            })
            ;(d.child_modules || []).forEach((ch) => {
              ch.businesses = ch.businesses || []
              ch.child_modules = ch.child_modules || []
            })
            return d
          });
          this.total = res['x-total-count'] || res.data.length
          if (this.total && !this.dataSource.length && this.page > 1) {
            this.page = this.page - 1
            this.getModuleList()
          }
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    showModuleModal() {
      this.moduleModal = true
    },
    cancelModule() {
      this.$refs.module.resetFields()
      this.moduleModal = false
    },
    showBusinessModal() {
      this.businessModal = true
    },
    cancelBusiness() {
      this.businessModal = false
    },
    saveModule() {
      this.$refs.module.validate((valid) => {
        if (valid) {
          this.moduleModalLoading = true
          this.curModule.config_type = this.configType
          editModuleApi(this.curModule)
            .then((res) => {
              this.moduleModalLoading = false
              if (res.code === 0) {
                this.pid = this.curModule.pid
                this.id = this.curModule.id
                this.cancelModule()
                this.getModuleList()
              } else {
                this.$Message.error(res.message)
              }
            })
            .catch(() => {
              this.moduleModalLoading = false
            })
        }
      })
    },
    editModule(row) {
      this.curModule = JSON.parse(JSON.stringify(row))
      this.showModuleModal(false)
    },
    addModule() {
      this.curModule = {
        id: '',
        name: '',
        alias: '',
        type: '目录',
        route: '',
        sort: 1,
        show: 0,
        disease_id: '',
        disease_name: '',
      }
      this.showModuleModal(false)
    },
    addBusModule(row) {
      this.curModule = {
        id: '',
        name: '',
        alias: '',
        type: '业务',
        route: '',
        sort: 1,
        show: 0,
        disease_id: '',
        disease_name: '',
        pid: row.id,
      }
      this.showModuleModal(false)
    },
    deleteModule(row) {
      deleteModuleApi(row.id).then((res) => {
        if (res.code === 0) {
          this.pid = row.pid
          this.id = row.id
          this.$Message.success('删除成功')
          this.getModuleList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    saveBusiness() {
      this.$refs.bus.validate((valid) => {
        if (valid) {
          this.businessModalLoading = true
          editBusinessApi(this.curBusiness)
            .then((res) => {
              this.businessModalLoading = false
              if (res.code === 0) {
                this.dataSource.forEach((m) => {
                  if (m.id == this.curBusiness.module_id) {
                    this.pid = m.pid
                    this.id = m.id
                  }
                  m.child_modules &&
                    m.child_modules.forEach((c) => {
                      if (c.id == this.curBusiness.module_id) {
                        this.pid = c.pid
                        this.id = c.id
                      }
                    })
                })
                this.businessModal = false
                this.getModuleList()
              } else {
                this.$Message.error(res.message)
              }
            })
            .catch(() => {
              this.businessModalLoading = false
            })
        }
      })
    },
    editBusiness(row) {
      const {
        module_id,
        module_name,
        name,
        code,
        route,
        bind_name,
        bind_code,
        id,
        show_trend,
        trend_type,
        trend_code,
      } = row
      this.curBusiness = {
        id,
        module_id,
        module_name,
        name,
        code,
        route,
        bind_name,
        bind_code,
        show_trend,
        trend_type,
        trend_code,
      }
      this.getInfo(this.curBusiness.bind_code)
      this.showBusinessModal()
    },
    addBusiness(row) {
      this.curBusiness = {
        module_id: row.id,
        module_name: row.name,
        name: '',
        code: '',
        route: '',
        bind_name: '',
        bind_code: '',
        show_trend: 0,
        trend_type: '',
      }
      this.group = []
      this.showBusinessModal()
    },
    deleteBusiness(row) {
      deleteBusinessApi(row.id).then((res) => {
        if (res.code === 0) {
          this.dataSource.forEach((m) => {
            if (m.id == row.module_id) {
              this.pid = m.pid
              this.id = m.id
            }
            m.child_modules &&
              m.child_modules.forEach((c) => {
                if (c.id == row.module_id) {
                  this.pid = c.pid
                  this.id = c.id
                }
              })
          })

          this.$Message.success('删除成功')
          this.getModuleList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
  },
}
</script>
<style lang="less">
.page-patientConfig {
  .ivu-table-expanded-cell {
    background: #fff;
    padding: 20px;
  }
  .error {
    color: #f56c6c;
    &:focus,
    &:hover {
      color: #f78989;
    }
  }
}
</style>
